import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'synfrastructure';
import VideoPlayer from '../../../common/video/VideoPlayer';
import { getCoursePreview } from '../redux/actions';
import Icon from '../../../common/icons/Icon';

class CoursePreviewModal extends Component {
  static propTypes = {
    courseId: PropTypes.number.isRequired,
    courseImage: PropTypes.string,
  };
  state = {
    modalVisible: false,
  };
  componentDidMount() {
    this.props.dispatch(getCoursePreview(this.props.courseId));
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.courseId !== this.props.courseId) {
      this.props.dispatch(getCoursePreview(nextProps.courseId));
    }
  }
  handleToggleModal = () => {
    this.setState((state, props) => ({
      modalVisible: !state.modalVisible,
    }));
  };
  renderVideoPlayer = () => {
    if (!this.state.modalVisible) {
      return null;
    }

    return <VideoPlayer autoplay video={this.props.video} poster={this.props.courseImage} />;
  };
  render() {
    return (
      <div>
        <button type="button" className="button--video-player" onClick={this.handleToggleModal}>
          Course Preview <Icon icon="PlayCircle" />
        </button>
        {this.props.video ? (
          <Modal isVisible={this.state.modalVisible} onClose={this.handleToggleModal}>
            <div className="modal__content--alt">
              <div className="video-player__modal-container">{this.renderVideoPlayer()}</div>
            </div>
          </Modal>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  video: state.subscription.courses.coursePreview.get('data'),
});

export default connect(mapStateToProps)(CoursePreviewModal);



// WEBPACK FOOTER //
// ./src/subscription/courses/components/CoursePreviewModal.js